import React, { Component } from "react";
import dataLayerObj from "./../../../data/dataLayerObj";
import extend from "extend";

const withDataLayer = WrappedComponent => {
    class WithDataLayer extends Component {
        constructor(props) {
            super(props);

            this.pushDataLayer = this.pushDataLayer.bind(this);
            this.cleanKeys = this.cleanKeys.bind(this);
        }

        pushDataLayer(params) {
            const { gtm, pageType, isMember } = window.dataLayer[0];
            const dateAsString = new Date().toString();
            const ip = sessionStorage.getItem("ip_address");
            const dl = Object.assign({}, dataLayerObj);

            let pushEvent = extend(dl, {
                "pageType": pageType,
                "gtm": gtm,
                "isMember": isMember,
                "timeStamp": dateAsString,
                "IPaddress": ip,
                ...params
            });

            pushEvent = this.cleanKeys(JSON.parse(JSON.stringify(pushEvent)));
            window.dataLayer.push(pushEvent);
        }

        cleanKeys(dataLayerObj) {
            return Object.assign(...Object.entries(dataLayerObj).map(([key, value]) => {
                return ({[key]: (value == null ? undefined : value)});
            }));
        }

        render() {
            return (
                <WrappedComponent
                    pushDataLayer={this.pushDataLayer}
                    {...this.props}
                />
            );
        }
    }
    return WithDataLayer;
};

export default withDataLayer;